// extracted by mini-css-extract-plugin
export default {"catalog_item":"style_catalog_item__ztblR","catalog_item_name":"style_catalog_item_name__1IXuI","catalog_item_img":"style_catalog_item_img__fO3wG"};